export const currencySymbol = (devise) => (devise === 'XOF' ? 'FCFA' : '€');

export const formatPrix = (prix, devise) => {
  const n = Number(prix);
  const txt = Number.isInteger(n)
    ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    : n.toFixed(2).replace('.', ',');
  return `${txt} ${currencySymbol(devise)}`;
};

export const findTarif = (category, duree) => {
  const t = (category?.tarifs || []).find(x => Number(x.duree) === Number(duree));
  return t && Number.isFinite(Number(t.prix)) ? Number(t.prix) : null;
};
